"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  xxs: 480,
  xs: 600,
  smTablet: 720,
  sm: 840,
  md: 960,
  lgTablet: 1024,
  lg: 1280,
  xl: 1440,
  xxl: 1600,
  xxxl: 1920
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-toolbox/lib/utils/breakpoints.js
// module id = 527
// module chunks = 0